export const BASE_URL = {
  ADMIN_TOOL_URL: 'https://gw-dev.cube.rina.org/admin-tool',
  ADMIN_TOOL_WEB: 'https://admin.cube.rina.org',
  WEBSOCKET_URL: 'https://cube-socket.azurewebsites.net/api',
  REST: 'https://gw-dev.cube.rina.org/rina-copilot-func-industry/dev',
};
